import { z } from 'zod'

/** Login input — our own email/password form. */
export const credentialsSchema = z.object({
  email: z.string().trim().min(1, 'Email is required.').email('Enter a valid email.'),
  password: z.string().min(1, 'Password is required.'),
})
export type Credentials = z.infer<typeof credentialsSchema>

/** Sign-up input. Password length is enforced here, once. */
export const signUpSchema = z.object({
  email: z.string().trim().min(1, 'Email is required.').email('Enter a valid email.'),
  password: z.string().min(8, 'Password must be at least 8 characters.'),
})
export type SignUpInput = z.infer<typeof signUpSchema>

/** Email-verification step: the emailed code + the pending token from signup/login. */
export const verifyEmailSchema = z.object({
  pendingToken: z.string().min(1),
  code: z.string().trim().min(4, 'Enter the code from your email.'),
})
export type VerifyEmailInput = z.infer<typeof verifyEmailSchema>

/** Social OAuth provider selector (the `?provider=` query value). */
export const providerSchema = z.enum(['google', 'microsoft', 'apple'])
export type ProviderSlug = z.infer<typeof providerSchema>

/** First validation message from a Zod error, for a friendly single-line API error. */
export function firstIssue(error: z.ZodError): string {
  return error.issues[0]?.message ?? 'Invalid request.'
}
